/**
 * Created by guandong.ni on 2017/8/15.
 */
function fontAdjust() {
  var u = 20 * document.documentElement.clientWidth / 375;
  if (u > 40) {
    u = 40;
  }
  document.documentElement.style.fontSize = u + 'px';
}
export default function() {
  'use strict';
  fontAdjust();
  window.addEventListener('resize', fontAdjust);
};



// WEBPACK FOOTER //
// ./src/component/common/adjust.js